import { useStore } from '@incodocs/react/controller';
import { sessionStore } from '../stores/session';

export function useSessionStore() {
  return useStore(sessionStore);
}
